
const routes = [
  {
    path: '/play',
    redirect: { name: 'PlayList' },
    meta: { layout: 'default' },
    children: [
      // 견학·체험 목록
      {
        path: 'list/:instId',
        name: 'PlayList',
        meta: { layout: 'default', menu: 'play', KeepAlive: true },
        component: () => import('@/pages/play/PlayListView.vue')
      },
      // 견학·체험 상세
      {
        path: 'detail/:instId',
        name: 'PlayDetail',
        meta: { layout: 'default', menu: 'play', KeepAlive: false },
        component: () => import('@/pages/play/PlayDetailView.vue'),
        props: (route) => ({
          instId: route.params.instId,
          ftrPrgrmId: route.query.ftrPrgrmId || ''
        })
      },
    ]
  }
]

export default routes


